import axios from '../axios'

/*
 * 轮播图
 */

export const selectByPage = (data) => {
    return axios({
        url: '/advertise/selectByPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/advertise/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/advertise/update',
        method: 'post',
        data
    })
}
export const batchUpdateStatus = (data) => {
    return axios({
        url: '/advertise/batchUpdateStatus',
        method: 'post',
        data
    })
}
export const batchDelete = (data) => {
    return axios({
        url: '/advertise/batchDelete',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/cms/advertise.js